/*!
 * FT Locations
 * Developers: Financial Times (Czarnie Salazar, Ian O'Sullivan, Robert Pender and Steven Neiland)
 */

import { default as utils } from "./../utils.min.js";

function openContactSidebar( sidebarid ){
	const $sidebar = $("#sidebar_contact");

	$sidebar.find(".panel-details").addClass("hidden");
	$(".contact-form-container").addClass("hidden");

	$sidebar.find(".contact-form-section").removeClass("hidden");
	$sidebar.find(".contact-success-section").addClass("hidden");
	$sidebar.find(".contact-error-section").addClass("hidden");
	
	let $selectedPanel = $("#contactpanel-" + sidebarid);
	$selectedPanel.removeClass("hidden");

	let showForm = $selectedPanel.data("showform");
	if( showForm ){
		$(".contact-form-container").removeClass("hidden");
		let $contactForm = $("form[name=ft_locations_contact_form]");
		$("#contactFormTitle").text( $selectedPanel.data("title") );
		$("#contactFormDescription").text( $selectedPanel.data("description") );
		$contactForm.find("textarea[name=message]").val( $selectedPanel.data("demoformtext") );
		$contactForm.find("input[name=blinkCode]").val( $selectedPanel.data("blinkcode") );
	}

	$sidebar.addClass("show");
	$(".ft-bg-overlay").addClass("show");
	$("body").addClass("overflow-hidden");
}

$(document).ready(function () {
	// Show - Right Panel
	$("body").on("click", ".solution-items li > a.toggle-item-panel", function (e) {
		e.preventDefault();
		const $this = $(this);
		const sidebarid = $this.data("sidebarid");
		openContactSidebar( sidebarid );
		$this.addClass("active");
	});

	// Hide - Right Panel
	$("body").on("click", ".ft-bg-overlay, .solution-panel > .btn-close", function (e) {
		e.preventDefault();

		const $FTOverlay = $(".ft-bg-overlay");

		// Remove active class in all items
		$(".js-ft-solution .solution-items li > a.item").removeClass("active");

		// Hide right panel detail
		$("#sidebar_contact").removeClass("show");
		$FTOverlay.removeClass("show");
		$("body").removeClass("overflow-hidden");

		// Clear FORM errors
		utils.clearFormErrors($("form[name=ft_locations_contact_form]"));
	});
});
